const STORAGE_KEY = 'pp-website-theme'

export type WebsiteTheme = 'light' | 'dark'

function defaultWebsiteTheme(): WebsiteTheme {
  return 'dark'
}

export function readWebsiteTheme(): WebsiteTheme {
  try {
    const value = localStorage.getItem(STORAGE_KEY)
    if (value === 'light' || value === 'dark') return value
  } catch {
    /* ignore quota / private mode */
  }
  return defaultWebsiteTheme()
}

export function writeWebsiteTheme(theme: WebsiteTheme) {
  try {
    localStorage.setItem(STORAGE_KEY, theme)
  } catch {
    /* ignore quota / private mode */
  }
}

function paintWebsiteTheme(theme: WebsiteTheme) {
  document.documentElement.dataset.wtTheme = theme
  document.documentElement.style.colorScheme = theme
}

/** Apply theme before paint to avoid flash. Safe on portal builds (ignored). */
export function bootWebsiteTheme() {
  const theme = readWebsiteTheme()
  paintWebsiteTheme(theme)
  return theme
}

export function applyWebsiteTheme(theme: WebsiteTheme) {
  paintWebsiteTheme(theme)
  writeWebsiteTheme(theme)
}
